export default "__VITE_ASSET__BkdO53ar__"